import axios from 'axios';
import PropTypes from 'prop-types';

// Set default axios configuration based on environment
const isDevelopment = process.env.NODE_ENV === 'development';
axios.defaults.baseURL = isDevelopment ? 'http://localhost:5000' : 'https://api.theexamhub.com';
axios.defaults.headers.common['Content-Type'] = 'application/json';

function App({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      {children}
    </div>
  );
}

App.propTypes = {
  children: PropTypes.node
};

export default App; 